import * as React from 'react';
import * as _ from 'lodash';
import * as Cookies from 'universal-cookie';
import { ITicket, IListItem, IUser, ITicketForList } from '@nkr/models/index';
import { TicketStatus, DisplayType, MessageType } from '@nkr/enums/index';
import { GridApi, GridReadyEvent, RowClickedEvent, ColumnResizedEvent, ColumnMovedEvent, DragStoppedEvent, ColumnApi } from 'ag-grid-community';
import { FormControl, Glyphicon, Popover } from 'react-bootstrap';
import { TicketAction } from './ticket-action';
import { AdminListWrapper } from './styles';
import { FormControlWrapper } from '@nkr/views/swap-management/swaps/styles';
import { IRefreshInterval } from '@nkr/views/swap-management/swaps/models';
import ReactHtmlParser from 'react-html-parser';
import styled from 'styled-components';
import DonorConnectGrid from './donor-connect-grid';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';

export const PopoverWrapper = styled(Popover) <{ width?: string }>`
    max-width: ${p => p.width ? p.width : '600px'};
    min-width: 500px;
    min-height: 600px;
    
    & > div {
        font-size: 12px;
    }
`;

const refreshIntervals: IRefreshInterval[] = [
    { value: 0, label: "Disable" },
    { value: 5, label: "5 seconds" },
    { value: 30, label: "30 seconds" },
    { value: 45, label: "45 seconds" },
    { value: 60, label: "60 seconds" }
];

interface IColumnDetails {
    colId: string,
    width: number,
    left: number
}

interface IProps {
    list: ITicketForList[],
    userList: IUser[],
    statusList: IListItem[],
    width: string,
    display: DisplayType,
    loading: boolean,
    autoRefresh: number,
    onOpen: (ticketId: number) => void,
    onCloseReopen: (ticketId: number, status: TicketStatus) => void,
    onResolve: (ticketId: number) => void,
    onChangeAssignedUser: (ticketId: number, userId: number) => void,
    onChangeStatus: (ticketId: number, status: number) => void,
    onChangeDisplay: (display: DisplayType) => void,
    onAutoRefreshChange: (autoRefresh: number) => void,
    onRefreshTicketList: () => void,
    onMouseOver: (id: number) => void,
    onMouseOut: () => void
}

interface IState {
    columnDetails: IColumnDetails[],
    currentTicket: number
}

class TicketingOnlyList extends React.Component<IProps, IState> {
    readonly state: IState = {
        columnDetails: [],
        currentTicket: 0
    }

    gridApi: GridApi;
    columnApi: ColumnApi;

    refreshInterval: any;
    countdownInterval: any;

    componentDidMount = () => {
        var cookies = new Cookies();
        var columnDetails = cookies.get("TicketingList");

        if (columnDetails != null) {
            this.setState({
                columnDetails
            });
        }
    }

    componentWillReceiveProps = (nextProps: IProps) => {
        if (nextProps.statusList.length != this.props.statusList.length && this.gridApi != undefined) {
            this.gridApi.refreshCells({ force: true });
        }

        if (nextProps.autoRefresh != this.props.autoRefresh) {
            clearInterval(this.refreshInterval);

            if (nextProps.autoRefresh > 0)
                this.refreshInterval = setInterval(() => this.refresh(), nextProps.autoRefresh * 1000);
        }
    }

    handleDisplayChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.props.onChangeDisplay(parseInt(e.currentTarget.value));
    }

    handleRefresh = () => {
        this.refresh();
    }

    handleAutoRefreshChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let autoRefresh = parseInt(e.currentTarget.value);
        this.props.onAutoRefreshChange(autoRefresh);
    }

    handleTicketAction = (id: number, action: TicketAction) => {
        switch (action) {
            case TicketAction.View:
                this.props.onOpen(id);
                break;

            case TicketAction.Close:
                this.props.onCloseReopen(id, TicketStatus.Closed);
                break;

            case TicketAction.Reopen:
                this.props.onCloseReopen(id, TicketStatus.Reopened);
                break;

            case TicketAction.Resolve:
                this.props.onResolve(id);
                break;
        }
    }

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.columnApi = e.columnApi;

        if (this.state.columnDetails.length == 0) {
            let columnDetails: IColumnDetails[] = this.columnApi.getAllColumns().map((column, left) => {
                let colId = column.getColId();
                let width = column.getActualWidth();

                return { colId, width, left };
            });

            this.setState({
                columnDetails
            });
        } else {
            this.state.columnDetails.forEach(column => {
                e.columnApi.moveColumn(column.colId, column.left);
                e.columnApi.setColumnWidth(column.colId, column.width);
            });
        }
    }

    handleRowClicked = (event: RowClickedEvent) => {
        let suppressRowClick = (event.api as any).gridOptionsWrapper.gridOptions.suppressRowClickSelection;

        if (!suppressRowClick) {
            let data = event.data as ITicket;
            this.props.onOpen(data.id);
        }
    }

    handleColumnResized = (event: ColumnResizedEvent) => {
        if (event.column != null) {
            let colId = event.column.getColId();
            let width = event.column.getActualWidth();

            let columnDetails = _.cloneDeep(this.state.columnDetails);
            let column = columnDetails.find(x => x.colId == colId);

            column.width = width;

            this.setState({
                columnDetails
            });
        }
    }

    handleColumnMoved = (event: ColumnMovedEvent) => {
        let colId = event.column.getColId();
        let left = event.toIndex;

        let columnDetails = _.cloneDeep(this.state.columnDetails);
        let currentColumn = columnDetails.find(x => x.colId == colId);
        let movedColumn = columnDetails.find(x => x.left == left);

        movedColumn.left = currentColumn.left < left ? movedColumn.left - 1 : movedColumn.left + 1;
        currentColumn.left = left;

        this.setState({
            columnDetails
        });
    }

    handleDragStopped = (event: DragStoppedEvent) => {
        let cookies = new Cookies();
        let columnDetails = this.state.columnDetails;

        cookies.set("TicketingList", columnDetails, { path: "/", domain: __DOMAIN__, secure: __ISSECURE__, httpOnly: false });
    }

    handleMouseOver = (e: React.MouseEvent, currentTicket: number) => {
        this.setState({
            currentTicket
        });
    }

    handleMouseOut = () => {
        this.setState({
            currentTicket: 0
        });
    }

    refresh = () => {
        this.props.onRefreshTicketList();
    }

    getOverlay = (ticketId: number) => {
        let ticket = this.props.list.find(x => x.id == ticketId);

        if (ticket == null) {
            return <></>;
        }

        let { type, from, fromEmail, to, cc, bcc, createdDateTime, subject, message } = ticket.message;

        return (
            <PopoverWrapper placement={'right'}>
                {type == MessageType.FirstContact && ticket.isEmail == false && (
                    <div style={{ marginBottom: 0 }}>
                        <div><strong>{from.fullName}</strong> submitted on {createdDateTime}</div>

                        {cc.length > 0 && (
                            <div>CC: {cc.map(x => x.email).join(', ')}</div>
                        )}

                        {bcc.length > 0 && (
                            <div>BCC: {bcc.map(x => x.email).join(', ')}</div>
                        )}
                    </div>
                )}

                {type == MessageType.FirstContact && ticket.isEmail == true && (
                    <div style={{ marginBottom: 0 }}>
                        <div><strong>{fromEmail}</strong> submitted on {createdDateTime}</div>

                        {cc.length > 0 && (
                            <div>CC: {cc.map(x => x.email).join(', ')}</div>
                        )}

                        {bcc.length > 0 && (
                            <div>BCC: {bcc.map(x => x.email).join(', ')}</div>
                        )}
                    </div>
                )}

                {type == MessageType.Note && (
                    <div style={{ marginBottom: 0 }}>
                        <div><strong>{from.fullName}</strong> posted on {createdDateTime}</div>
                    </div>
                )}

                {type == MessageType.Reply && (
                    <div style={{ marginBottom: 0 }}>
                        <div><strong>{from.fullName}</strong> replied on {createdDateTime}</div>

                        {cc.length > 0 && (
                            <div>CC: {cc.map(x => x.email).join(', ')}</div>
                        )}

                        {bcc.length > 0 && (
                            <div>BCC: {bcc.map(x => x.email).join(', ')}</div>
                        )}
                    </div>
                )}

                {type == MessageType.Forward && (
                    <div style={{ marginBottom: 0 }}>
                        <div><strong>{from.fullName}</strong> forwarded to {to.map(x => x.email).join(',')} on {createdDateTime}</div>

                        {cc.length > 0 && (
                            <div>CC: {cc.map(x => x.email).join(', ')}</div>
                        )}

                        {bcc.length > 0 && (
                            <div>BCC: {bcc.map(x => x.email).join(', ')}</div>
                        )}
                    </div>
                )}

                <div style={{ marginBottom: 10 }}>Subject: {subject}</div>
                {ReactHtmlParser(message)}
            </PopoverWrapper>
        );
    }

    render = () => {
        const userList = this.props.userList;
        const statusList = this.props.statusList;
        const ticketList = this.props.loading == false ? this.props.list : [];

        const groupList = _.sortBy(_.uniqBy(this.props.userList.map(x => x.group), (item) => item.id), item => item.id);

        return (
            <>
                <div style={{ position: 'absolute', top: '10%', left: '27%', width: '80%', zIndex: 99999 }}>
                    {this.getOverlay(this.state.currentTicket)}
                </div>

                <AdminListWrapper style={{ width: this.props.width ? this.props.width : '87%' }}>
                    <DonorConnectGrid
                        data={ticketList}
                        display={this.props.display}
                        userList={userList}
                        userGroupList={groupList}
                        statusList={statusList}
                        onGridReady={this.onGridReady}
                        onRowClicked={this.handleRowClicked}
                        onColumnResized={this.handleColumnResized}
                        onColumnMoved={this.handleColumnMoved}
                        onDragStopped={this.handleDragStopped}
                        onMouseOver={this.handleMouseOver}
                        onMouseOut={this.handleMouseOut}
                        onChangeAssignedUser={this.props.onChangeAssignedUser}
                        onChangeStatus={this.props.onChangeStatus}
                    />

                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
                        <div style={{ fontSize: 12 }}>
                            {this.props.list.length} ticket(s) ...
                        </div>

                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ marginRight: 5, fontSize: 12 }}>Show:</div>
                            <div style={{ marginRight: 10 }}>
                                <FormControlWrapper
                                    value={this.props.display}
                                    componentClass="select"
                                    style={{ fontSize: 12 }}
                                    onChange={this.handleDisplayChange}
                                >
                                    <option value='1'>Menus</option>
                                    <option value='4'>No Menus</option>
                                </FormControlWrapper>
                            </div>
                        </div>

                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ marginRight: 5, fontSize: 12 }}>Auto refresh:</div>
                            <div style={{ marginRight: 5 }}>
                                <FormControlWrapper
                                    value={this.props.autoRefresh}
                                    componentClass="select"
                                    style={{ fontSize: 12 }}
                                    onChange={this.handleAutoRefreshChange}
                                >
                                    {refreshIntervals.map((interval, index) =>
                                        <option key={index} value={interval.value}>{interval.label}</option>
                                    )}
                                </FormControlWrapper>
                            </div>
                            <div>
                                <Glyphicon glyph="refresh" title="Refresh now" onClick={this.handleRefresh} />
                            </div>
                        </div>
                    </div>
                </AdminListWrapper>
            </>
        );
    }
}

export default TicketingOnlyList;